/**
 * Known type of items mapping to configurations with handlers and temaplates
 */
export enum KnownItemTypes {
    calendarInDayItems = 0,
    calendarAllDayItems = 1,
    overflowIndicator = 2,
    quickAddItem = 3,
    dragDropInDayItem = 4,
    attendeesItems = 5,
    suggestedItems = 6,
    dragDropAllDayItem = 7,
}
